import * as React from "react";
import clsx from "clsx";
import * as s from "./Card.style.css";

export interface CardProps {
  children: React.ReactNode;
  maxWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function Card({ children, maxWidth = 440, className, style }: CardProps) {
  return (
    <div
      className={clsx(s.card, className)}
      style={
        {
          "--card-max-width": `${maxWidth}px`,
          ...style,
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
}
